<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { filedrop } from "filedrop-svelte";
    import type { Files } from "filedrop-svelte";
    import { onMount } from "svelte";
    import IconUpload from "../../shared/Icons/IconUpload.svelte";
    import { api } from "../../../stores/api";
    import { ImportApi } from "../Import/ImportApi";
    import {
        currentImport,
        ImportResponseSchema,
    } from '../../shared/ColumnSelectPro/currentImport';
    import Spinner from '../../shared/Spinner/Spinner.svelte';
    import { openModal } from 'svelte-modals';
    import ModalError from '../../shared/Modals/ModalError.svelte';
    import SplitButton from "../../shared/SplitButton.svelte";
    import IconAddWhite from "../../shared/Icons/IconAddWhite.svelte";
    import { Navigation } from "../../utilities/Navigation";

    let files: Files;
    let acceptImportFileTypes: string | null = null;
    let uploadingInProgress: boolean = false;

    let fileOverEvents: number = 0;
    let fileover: boolean = false;

    function upload() {
        fileover = false;
        uploadingInProgress = true;
        let importName = 'import_' + new Date().toISOString().slice(0, 10);
        ImportApi.create($api, {
            name: importName,
            import_type: 'upsert',
            file_type: 'locations',
        }).then(response => {
            ImportResponseSchema.parse(response);
            $currentImport = response;

            if ($currentImport !== null) {
                $api
                    .sendFiles<unknown>(
                        files.accepted,
                        '',
                        `/import/${$currentImport.id}/upload`
                    )
                    .then(response => {
                        Navigation.navigate('/assign-columns');
                    })
                    .catch(response => {
                        console.error('error response', response);
                        if (response.code === 'import-upload-too-many-lines') {
                            let currentLines = response.variables[0].current ?? null;
                            let maxLines = response.variables[0].max ?? null;
                            if (currentLines !== null && maxLines !== null) {
                                openModal(ModalError, {
                                    header: $_('error'),
                                    message: $_(
                                        'too_many_lines_current_max',
                                        { values: { currentLines, maxLines } }
                                    ),
                                });
                            } else if (maxLines !== null) {
                                openModal(ModalError, {
                                    header: $_('error'),
                                    message: $_(
                                        'too_many_lines_max',
                                        { values: { maxLines } }
                                    ),
                                });
                            } else {
                                openModal(ModalError, {
                                    header: $_('error'),
                                    message: $_('too_many_lines'),
                                });
                            }
                        } else {
                            openModal(ModalError, {
                                header: $_('error'),
                                message: $_('upload_file_error'),
                            });
                        }
                        if ($currentImport !== null) {
                            $currentImport.columns_assignment = null;
                        }
                    })
                    .finally(() => {
                        uploadingInProgress = false;
                    });
            }
        }).catch(err => {
            uploadingInProgress = false;
        });
    }

    onMount(() => {
        ImportApi.getAvailableTypes($api)
            .then(response => {
                acceptImportFileTypes = response.map(t => '.' + t).join(', ');
            });
    });

    $: {
        if (files && files.accepted) {
            upload();
        }
    }
</script>

{#if acceptImportFileTypes}
    <div
        use:filedrop={{accept: acceptImportFileTypes, clickToUpload: false}}
        on:filedrop={e => { files = e.detail.files; }}
        on:filedragenter={() => { fileOverEvents++; fileover = true; }}
        on:filedragleave={() => { fileOverEvents--; if (fileOverEvents === 0) fileover = false; }}
        class="container"
        class:fileover
    >
        <SplitButton
            text={$_('Add_jobs')}
            handler={() => { document.querySelector('input[type=file]')?.click(); }}
            icon={{name: IconAddWhite, props: {scale: 0.7}}}
            options={[
                {text: $_('Upload file'), handler: () => { document.querySelector('input[type=file]')?.click(); }},
                {text: $_('Add job manually'), handler: () => { Navigation.navigate('/manual-add-job'); }}
            ]}
        />
        <div class="upload-notice">
            <div style="display: flex; align-items: center; justify-content: center"><IconUpload scale={0.7}/> {$_('Drag and drop files here')}</div>
            <div>
                <div>{$_('Available formats')}: {acceptImportFileTypes}</div>
            </div>
        </div>
        <div class="progress-overlay" class:visible={uploadingInProgress}>
            <Spinner/>
        </div>
    </div>
{/if}

<style>
    .container {
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding: 3px;
        border-radius: 7px;
        border: 2px dashed #1b5abf99;
        background-color: #469ef422;
        position: relative;
        top: -5px;
    }
    .fileover {
        padding: 3px;
        border: 2px dashed #1b5abf;
        background-color: #469ef444;
    }
    .upload-notice {
        text-align: center;
        font-size: 12px;
    }
    .progress-overlay {
        display: none;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background-color: #ffffffcc;
    }
    .progress-overlay.visible {
        display: block;
    }
</style>